import React from 'react';
import PropTypes from 'prop-types';
import {Button as SButton} from 'semantic-ui-react';

const Button = ({children, loading, neutral, ...props}) => (
  <SButton
    disabled={loading}
    loading={loading}
    primary={!neutral}
    type="button"
    {...props}
  >
    {children}
  </SButton>
);

Button.defaultProps = {
  children: null,
  loading: false,
  neutral: false,
};

Button.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  neutral: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Common/Structure/Button.js